import {
  instance,
} from './index';

const getTagGroup = async (data) => {
  const { id } = data;
  const res = await instance.get(`/tag-groups/${id}`);
  return res;
};
const getTagGroups = async (data) => {
  const res = await instance.post('/tag-groups/all', data);
  return res;
};
const updateTagGroup = async (data) => {
  const res = await instance.put('/tag-groups', data);
  return res;
};
export {
  getTagGroup,
  getTagGroups,
  updateTagGroup,
};
